// extracted by mini-css-extract-plugin
module.exports = {"c_rule":"Rule_c_rule__CDN_j"};